<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Premies lijfrente als aanvulling op je pensioen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een lijfrente is extra inkomen vanaf het moment dat je met pensioen gaat. Je kunt daarvoor een
                verzekering
                afsluiten of bijvoorbeeld bedragen storten op een lijfrenterekening of voor een
                lijfrentebeleggingsrecht. Het bedrag op je spaarrekening of de waarde van je recht moet je dan op een
                bepaald moment gebruiken voor de aankoop van een lijfrente.
                <div class="space10"></div>

                De premies voor de lijfrenteverzekering of de stortingen op een lijfrenterekening of
                lijfrentebeleggingsrecht mag je alleen aftrekken van je inkomen als je een pensioentekort hebt. Je hebt
                bijvoorbeeld een pensioentekort als je geen of onvoldoende pensioen opbouwt bij een werkgever.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Soorten lijfrenten
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Om aftrek te krijgen moet de lijfrente voldoen aan bepaalde voorwaarden. Aan welke voorwaarden de
                lijfrente moet voldoen, is afhankelijk van de instelling waar je de lijfrente hebt afgesloten en het
                soort lijfrente. Het kan gaan om:
                <li class="list">een lijfrenteverzekering bij een levensverzekeringsmaatschappij</li>
                <li class="list">een lijfrenterekening bij een bank</li>
                <li class="list">een lijfrentebeleggingsrecht bij een beleggingsonderneming of beheerder van een
                    beleggingsinstelling
                </li>
                <div class="space10"></div>

                <b>Lijfrenteverzekering</b>
                Je mag premies aftrekken als je 1 van de volgende soorten lijfrenteverzekeringen hebt:
                <li class="list">oudedagslijfrente</li>
                <li class="list">tijdelijke oudedagslijfrente</li>
                <li class="list">nabestaandenlijfrente</li>
                <li class="list">overbruggingslijfrente</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Als de lijfrente niet meer voldoet aan de voorwaarden
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voldoet je lijfrente niet meer aan de voorwaarden? Dan moet je belasting betalen over de waarde van deze
                lijfrente. Je moet in de meeste gevallen 'revisierente' betalen.
                <div class="space10"></div>

                In de volgende gevallen voldoet je lijfrente niet meer aan de voorwaarden:
                <li class="list">je hebt de lijfrente aan iemand geschonken, verkocht, verpand of beleend. Beleend wil zeggen dat u
                    een lening hebt opgenomen met de lijfrente als onderpand.
                </li>
                <li class="list">je hebt de voorwaarden van de lijfrente of beroepspensioenregeling zo laten veranderen dat deze niet
                    meer aan de wettelijke voorwaarden voldoet.
                </li>
                <li class="list">je bent niet meer de rekeninghouder van de lijfrenterekening of de eigenaar van het
                    lijfrentebeleggingsrecht.
                </li>
                <li class="list">je hebt de lijfrenteverzekering afgekocht of de lijfrenterekening of het lijfrentebeleggingsrecht
                    gedeblokkeerd.
                </li>
                <div class="space10"></div>

                Zet je je lijfrente niet tijdig om of laat je deze niet tijdig ingaan? Dan heeft dit ook gevolgen voor
                de belasting die je moet betalen.
                <div class="space10"></div>

                Als je lijfrente niet meer aan de voorwaarden voldoet, moet je naast wellicht revisierente ook belasting
                betalen over de waarde van je lijfrenteverzekering of –beleggingsrecht of het tegoed op je
                lijfrenterekening.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Wanneer moeten betalingen zijn gedaan?
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je mag de premies voor lijfrenten en de stortingen op een lijfrenterekening of lijfrentebeleggingsrecht
                in {{ this.year }} aftrekken als je deze in {{ this.year }} hebt betaald.
            </div>
        </div>
    </div>

</div>

